import format from "date-fns/format";
import React, { useMemo } from "react";

export const JsonLd = ({ data }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
);
export const JsonLdTags = ({ merchant, reviews }) => {
  const reviewMap = (review, merchant) => {
    if (!review.rating || review.platform) {
      return null;
    }

    return {
      "@type": "Review",
      reviewRating: {
        "@type": "Rating",
        ratingValue: review.rating,
        bestRating: 5,
        worstRating: 1,
      },
      author: {
        "@type": "Person",
        name: review.name,
      },
      reviewBody: review.comment,
      datePublished: format(review.created_at, "YYYY-M-DD"),
    };
  };

  const reviewsMap = useMemo(() => {
    if (!reviews) return [];
    return reviews.map((r) => reviewMap(r, merchant)).filter((r) => !!r);
  }, [reviews, merchant]);

  const data = {
    "@context": "http://schema.org",
    "@type": "LocalBusiness",
    name: merchant.name,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: Math.round(merchant.averageRating * 10) / 10,
      ratingCount: merchant.numRatings || merchant.numReviews,
      bestRating: 5,
    },
    review: reviewsMap,
    address: {
      "@type": "PostalAddress",
      streetAddress: merchant.listingAddress,
      postalCode: merchant.listingZip,
      addressLocality: merchant.listingCity,
      addressRegion: merchant.listingState,
    },
  };
  return <JsonLd data={data} />;
};



// WEBPACK FOOTER //
// ./src/components/JsonLd.js